// extracted by mini-css-extract-plugin
export var song_card = "SongCard-module--song_card--A68Bq";
export var song_card_thumbnail = "SongCard-module--song_card_thumbnail--L631c";
export var song_card_name = "SongCard-module--song_card_name--kubqO";
export var song_card_date = "SongCard-module--song_card_date--a4i66";
export var song_card_duration = "SongCard-module--song_card_duration--6bWXI";
export var song_card_icon = "SongCard-module--song_card_icon--2SAYC";
export var cc = "SongCard-module--cc--Mxddd";
export var translated = "SongCard-module--translated--Mvfq6";